import React from 'react';

export const renderLink = (value) => {
  return <a href={value} target="_blank" rel="noreferrer">link</a>;
};
